import { axiosService, ServiceEndPoint } from "./common/Axios.service";

const SERVICE_URL = ServiceEndPoint.account_service;

export const fetchMetaData = async () => {
  try {
   
    const response = await  axiosService.get(`${SERVICE_URL}form-meta/asn_create`);
    return response.data;
  } catch (error) {
    console.error("Error fetching validation data", error);
    throw error;
  }
};
